<template>
  <Breadcrumbs
      title="Stock Adjustment Approval"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Stock Adjustment', path: '/stock-adjustment-approval' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <stockAdjustmentApprovalForm />

    </div>
  </div>
</template>


<script>
import stockAdjustmentApprovalForm from '@/pages/stock/stock_adjustment_approval/stockAdjustmentApprovalForm.vue';

export default {
  components: {
    stockAdjustmentApprovalForm
  }
}
</script>